export default "<button title=\"{{'BUTTONS.EDIT' | translate}}\" class=\"btn {{btn_class}}\" (click)=\"Edit()\">{{'BUTTONS.EDIT' | translate}}</button>\r\n";